import { styled } from "@vitality-ds/system";
import BaseInputWrapperStyles from "./styles/BaseInputWrapper.styles";
import BaseTextInputStyles from "./styles/BaseTextInput.styles";
// eslint-disable-next-line import/prefer-default-export
export var BaseTextInput = styled("input", BaseTextInputStyles);
export var BaseInputWrapper = styled("div", BaseInputWrapperStyles);